import { type FC } from 'react';
import { Link } from 'react-router-dom';
import { type ICallAccount } from '@/types/ICallAccount';
import { formatCallAccountName } from '@/utils/formatCallAccountName';
import { getCallAccountRows } from '@/utils/getCallAccountRows';
import styles from './callAccountCard.module.scss';

interface ICallAccountCardProps {
  account: ICallAccount | null;
  accountPath: string | null;
}

const NOT_FOUND_TITLE = 'Аккаунт в БД не найден';
const NOT_FOUND_HINT = 'Номер не привязан ни к одному аккаунту.';
const NAMELESS_TITLE = 'Имя не указано';
const LINK_LABEL = 'Открыть аккаунт';

/**
 * Карточка аккаунта клиента в модалке звонка. Отдельно обрабатывает валидный
 * сценарий «аккаунт не найден» — звонок с непривязанного номера.
 */
export const CallAccountCard: FC<ICallAccountCardProps> = ({
  account,
  accountPath
}) => {
  if (account === null) {
    return (
      <div className={styles['call-account-card']}>
        <p className={styles['call-account-card__empty-title']}>
          {NOT_FOUND_TITLE}
        </p>
        <p className={styles['call-account-card__empty-hint']}>
          {NOT_FOUND_HINT}
        </p>
      </div>
    );
  }

  const name = formatCallAccountName(account);
  const rows = getCallAccountRows(account);

  return (
    <div className={styles['call-account-card']}>
      <div className={styles['call-account-card__head']}>
        <span className={styles['call-account-card__name']}>
          {name === '' ? NAMELESS_TITLE : name}
        </span>
        {accountPath !== null && (
          <Link
            className={styles['call-account-card__link']}
            to={accountPath}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LINK_LABEL}
          </Link>
        )}
      </div>

      <dl className={styles['call-account-card__rows']}>
        {rows.map((row) => (
          <div className={styles['call-account-card__row']} key={row.label}>
            <dt className={styles['call-account-card__label']}>{row.label}</dt>
            <dd className={styles['call-account-card__value']}>{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
